@if (anchor) {
  <a [id]="anchor"></a>
}

@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

@if (attributes.medium.component === 'image') {
  <figure
    kb-figure
  >
    <kb-picture-lightbox #lightboxElement [picture]="imageToPicture(attributes.medium.attributes, aspectRatio).sources" [alt]="attributes.medium.attributes.alt">
      <kb-picture [appEditorId]="attributes.medium.editorIds?.src"
        [appOgImage]="attributes.medium.attributes"
        [picture]="imageToPicture(attributes.medium.attributes, aspectRatio).sources"
        [alt]="attributes.medium.attributes.alt"
        [rootColumns]="attributes.numColumns"
      ></kb-picture>
    </kb-picture-lightbox>
    @if (attributes.medium.attributes.caption || attributes.medium.attributes.downloadUrls) {
      <figcaption>
        @if (attributes.medium.attributes.caption) {
          <kb-line-clamp lines="2" [appEditorId]="attributes.medium.editorIds?.caption">{{ attributes.medium.attributes.caption }}</kb-line-clamp>
        }
        @if (attributes.medium.attributes.downloadUrls) {
          <a class="download" kb-icon [icon]="iconDownload" icon-uppercase icon-center
            download [href]="attributes.medium.attributes.downloadUrls.high" target="_blank"
            i18n-aria-label="label for the image download button@@3099741642167775297" aria-label="Download"
            i18n-title="label for the image download button@@3099741642167775297" title="Download"
          ></a>
        }
      </figcaption>
    }
  </figure>
}

@if (isVideoSection(attributes.medium);) {
  <app-video
    [attributes]="attributes.medium.attributes"
    [editorIds]="attributes.medium.editorIds"
  ></app-video>
}
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
